import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import HttpAPICall from '../../../services/HttpAPICall';
import { INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import { Modal } from 'bootstrap';
import ConsumptionCycleTabUI from './ConsumptionCycleTabUI';

function ConsumptionCycleTabContainer(props) {
  const [demand_loading, setDemand_loading] = useState(false);
  const [demand_listing, setDemand_listing] = useState([]);
  const [demandlistingMeta, setDemandlistingMeta] = useState({});
  const [selectedDemandId, setSelectedDemandId] = useState(null);
  const [allocationlistingMeta, setAllocationlistingMeta] = useState(null);
  const [consumptionlistingMeta, setConsumptionlistingMeta] = useState(null);
  const [allocation_listing, setAllocation_listing] = useState([]);
  const [consumption_listing, setConsumption_listing] = useState([]);
  const [allocation_loading, setAllocation_loading] = useState(false);
  const [consumption_loading, setConsumption_loading] = useState(false);
  const [selectedAllocationId, setSelectedAllocationId] = useState("");
  const [selectedConsumptionId, setSelectedConsumptionId] = useState("");
  const [showOtherDetail, setShowOtherDetail] = useState(
    props?.config?.showOtherDetail === "N" ? "N" : "Y"
  );

  const viewDemandDetailModalRef = useRef(null);
  const viewAllocationDetailModalRef = useRef(null);
  const viewConsumptionDetailModalRef = useRef(null);

  const permissions = useSelector(state => state.app.acl_info?.permissions || []);
  const accessToken = useSelector(state => state.auth.access_token);
  const group_permission = useSelector(state => state.app.acl_info);

  const demandListUrl = INVENTORY_API_BASE_URL_2 + "/item_demand/list";
  const allocationListUrl = INVENTORY_API_BASE_URL_2 + "/allocations";
  const consumptionListUrl = INVENTORY_API_BASE_URL_2 + "/consumptions";

  const defaultConfig = {
    type: 'ticket',
    idKey: 'activity_id',
    showDemand: true,
    showAllocation: true,
    showConsumption: true,
    showAddButtons: true,
    showTotalSummary: true,
    loadOnMount: true,
    searchParams: {},
    additionalParams: {},
  };

  const config = { ...defaultConfig, ...props.config };
  const idValue = props.id || props.data?.id || props.ticketData?.activity_id;
  const ticketAllData = props.ticketData

  const getSearchParams = (page) => {
    const params = { page: page, ...config.additionalParams };
    
    if (config.type === 'ticket') {
      params.search_ticket_id = idValue;
    } else if (config.type === 'sub_assembly') {
      params.search_sub_assembly_id = idValue;
    }
    
    return { ...params, ...config.searchParams };
  };

  const getDemandList = (page = 1) => {
    if (!config.showDemand) return;
    setDemand_loading(true);
    const params = getSearchParams(page);
    
    HttpAPICall.withAthorization("GET", demandListUrl, accessToken, params, {}, (resp) => {
      const respData = resp.data;
      setDemand_listing(respData.data || []);
      setDemandlistingMeta({
        from: respData.from,
        to: respData.to,
        total: respData.total,
        last_page: respData.last_page,
        per_page: respData.per_page,
        current_page: respData.current_page,
      });
    }).finally(() => setDemand_loading(false));
  };

  const getAllocationList = (page = 1) => {
    if (!config.showAllocation) return;
    setAllocation_loading(true);
    const params = getSearchParams(page);
    
    HttpAPICall.withAthorization("GET", allocationListUrl, accessToken, params, {}, (resp) => {
      const respData = resp.data;
      setAllocation_listing(respData.data || []);
      setAllocationlistingMeta(respData.meta);
    }).finally(() => setAllocation_loading(false));
  };

  const getConsumptionList = (page = 1) => {
    if (!config.showConsumption) return;
    setConsumption_loading(true);
    const params = getSearchParams(page);
    
    HttpAPICall.withAthorization("GET", consumptionListUrl, accessToken, params, {}, (resp) => {
      const respData = resp.data;
      setConsumption_listing(respData.data || []);
      setConsumptionlistingMeta(respData.meta);
    }).finally(() => setConsumption_loading(false));
  };

  const viewDemandDetail = (id) => {
    if (showOtherDetail === "Y") {
      setSelectedDemandId(id);
      viewDemandDetailModalRef.current?.show();
    }
  };

  const viewAllocationDetail = (id) => {
    if (showOtherDetail === "Y") {
      setSelectedAllocationId(id);
      viewAllocationDetailModalRef.current?.show();
    }
  };

  const viewConsumptionDetail = (id) => {
    if (showOtherDetail === "Y") {
      setSelectedConsumptionId(id);
      viewConsumptionDetailModalRef.current?.show();
    }
  };

  useEffect(() => {
    if (showOtherDetail === "Y") {
      const demandModalElement = document.getElementById("viewDemandDetailModal");
      const allocationModalElement = document.getElementById("viewAllocationDetailModal");
      const consumptionModalElement = document.getElementById("viewConsumptionDetailModal");

      if (demandModalElement && !viewDemandDetailModalRef.current) {
        viewDemandDetailModalRef.current = new Modal(demandModalElement, { keyboard: false, backdrop: false });
      }
      if (allocationModalElement && !viewAllocationDetailModalRef.current) {
        viewAllocationDetailModalRef.current = new Modal(allocationModalElement, { keyboard: false, backdrop: false });
      }
      if (consumptionModalElement && !viewConsumptionDetailModalRef.current) {
        viewConsumptionDetailModalRef.current = new Modal(consumptionModalElement, { keyboard: false, backdrop: false });
      }
    }
  }, [showOtherDetail]);

  useEffect(() => {
    return () => {
      viewDemandDetailModalRef.current?.hide();
      viewAllocationDetailModalRef.current?.hide();
      viewConsumptionDetailModalRef.current?.hide();
    };
  }, []);

  useEffect(() => {
    if (!config.loadOnMount || !idValue) return;
    
    const hasIscAccess = group_permission?.group_modules?.includes("isc");
    if (!hasIscAccess) return;

    if (config.showDemand) getDemandList(1);
    if (config.showAllocation) getAllocationList(1);
    if (config.showConsumption) getConsumptionList(1);
  }, [idValue]);

  const uiData = {
    demand_listing,
    demandlistingMeta,
    demand_loading,
    allocation_listing,
    allocationlistingMeta,
    allocation_loading,
    consumption_listing,
    consumptionlistingMeta,
    consumption_loading,
    selectedDemandId,
    selectedAllocationId,
    selectedConsumptionId,
    default_currency: props?.data?.default_currency,
    permissions,
    group_permission,
    showOtherDetail,
    config,
    idValue,
    getDemandList,
    getAllocationList,
    getConsumptionList,
    viewDemandDetail,
    viewAllocationDetail,
    viewConsumptionDetail,
    viewDemandDetailModalRef,
    viewAllocationDetailModalRef,
    viewConsumptionDetailModalRef,
    ticketAllData
  };

  return <ConsumptionCycleTabUI {...uiData} />;
}

export default ConsumptionCycleTabContainer;